export const SET_ANONYMOUS_PENDING_REQUEST = 'setAnonymousPendingRequest'
export const SET_CONDUENT_SESSION_ID = 'setConduentSessionId'
export const SET_PLUGGED_SUPPORT_ID = 'setPluggedSupportId'
export const SET_SUPPORT_CONTENT = 'setSupportContent'
